// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { forwardRef, ReactNode, Ref } from 'react';

import { BaseProps } from '../Base';
import { Size } from './';
import { StyledInputWrapper } from './Styled';

export interface InputWrapperProps extends BaseProps {
  leadingIcon?: ReactNode;
  onLeadingIconClick?: () => void;
  sizing?: Size;
  children?: ReactNode | ReactNode[];
  hasPasswordVisibilityToggleButton?: boolean;
}

export const InputWrapper = forwardRef(
  (props: InputWrapperProps, ref: Ref<HTMLDivElement>) => {
    const {
      leadingIcon,
      children,
      sizing,
      hasPasswordVisibilityToggleButton,
      onLeadingIconClick,
      ...rest
    } = props;

    return (
      <StyledInputWrapper
        ref={ref}
        sizing={sizing}
        leadingIcon={leadingIcon}
        hasPasswordVisibilityToggleButton={hasPasswordVisibilityToggleButton}
        {...rest}
        data-testid="input-wrapper"
      >
        {leadingIcon && (
          <span className="ch-icon" onClick={onLeadingIconClick}>
            {leadingIcon}
          </span>
        )}
        {children}
      </StyledInputWrapper>
    );
  }
);
InputWrapper.displayName = 'InputWrapper';

export default InputWrapper;
